import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';
import Phone from 'pages/Phone';
import { URLS } from 'config';

import './styles.scss';

class Login extends React.Component {
    state = { isOpen: true }

    goBack = () => {
      this.props.history.goBack();
    }

    goReturned = () => {
      this.props.history.replace(URLS.RETURNED);
    }

    render () {
      if (Object.keys(this.props.user).length) {
        return <Redirect to={URLS.PROFILE} />;
      }
      return (
        <Modal isOpen={this.state.isOpen}>
          <ModalHeader backHandl={this.goBack}>
            Login
          </ModalHeader>
          <Phone {...this.props} handlAfterSuccess={this.goReturned} />
        </Modal>
      );
    }
}

Login.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  user: state.user.user
});


export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/index.js